<div class="modal__backdrop" (click)="onBackdropClick()"></div>
<div
  class="modal__container"
  [style.width]="width"
  [style.max-width]="maxWidth"
  role="dialog"
  aria-modal="true"
>
  <div class="modal__body">
    <ng-container #contentContainer></ng-container>
  </div>
</div>
